module.exports = __webpack_public_path__ + "img/07-03_Being Determined.92863db0.svg";